import { useMutation } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { fetcher } from '@/api/fetcher';
import { PostStudyLogError, PostStudyLogRequest, PostStudyLogResponse } from '@/api/model';

const KEY = {
  POST_STUDY_LOG: 'POST_STUDY_LOG',
} as const;

const request = {
  postStudyLog: async ({ payload: { body, studyId } }: PostStudyLogRequest) => {
    const { data } = await fetcher.APPS.post<PostStudyLogResponse>(
      `${ENDPOINTS.APPS.STUDY}${studyId}/log`,
      { body },
    );

    return data;
  },
};

const mutation = {
  usePostStudyLog: () =>
    useMutation<PostStudyLogResponse, PostStudyLogError, PostStudyLogRequest>({
      mutationFn: request.postStudyLog,
    }),
};

export const studyLog = {
  KEY,
  mutation,
  request,
};
